import { render, staticRenderFns } from "./kechengchongzhi.vue?vue&type=template&id=fba9a6fe&scoped=true"
var script = {}
import style0 from "./kechengchongzhi.vue?vue&type=style&index=0&id=fba9a6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba9a6fe",
  null
  
)

export default component.exports